import * as types from './types';

export default {
  state: {
    teacherList: [],
  },
  getters: {
    [types.TEACHER_LIST]: state => state.teacherList,
  },
  mutations: {
    [types.TEACHER_LIST]: (state, payload) => {
      state.teacherList = payload.teacherList;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/learning-center/create-teacher/index.js